/** @type {import('tailwindcss').Config} */

export default {
  content: ['./src/components/**/*.jsx', './storybook/**/*.jsx'],

  theme: {
    extend: {
      fontFamily: {
        sans: ['Geograph', 'sans-serif'],
        serif: ['Self Modern', 'serif'],
      },
      fontMetrics: {
        sans: {
          familyName: 'Copyright Klim Type Foundry',
          fullName: 'Geograph',
          postscriptName: 'Geograph-Regular',
          capHeight: 730,
          ascent: 1031,
          descent: -257,
          lineGap: 0,
          unitsPerEm: 1000,
        },
        serif: {
          familyName: 'Self Modern',
          fullName: 'Self Modern',
          postscriptName: 'SelfModern-Regular',
          capHeight: 780,
          ascent: 1050,
          descent: -250,
          lineGap: 0,
          unitsPerEm: 1000,
        },
      },
      boxShadow: {
        inputError:
          '0 2px 0 0 rgb(182, 81, 81), 2px 0 0 0 rgb(182, 81, 81), 0 0 0 2px rgb(182, 81, 81)',
      },
      aspectRatio: {
        '2/1': '2 / 1',
        '3/1': '3 / 1',
        '4/1': '4 / 1',
        '4/5': '4 / 5',
        '5/4': '5 / 4',
        '6/7': '6 / 7',
      },
      colors: {
        black: {
          100: '#f5f5f5',
          200: '#e5e5e5',
          300: '#d4d4d4',
          400: '#a3a3a3',
          500: '#212121',
          DEFAULT: '#212121',
          600: '#181818',
          700: '#121212',
          800: '#0a0a0a',
          900: '#000000',
        },
        neutral: {
          50: '#FFFFFF',
          100: '#FDFCFC',
          200: '#FBFAF9',
          300: '#FAF9F7',
          400: '#F9F8F6',
          500: '#F8F7F5',
          DEFAULT: '#F8F7F5',
          600: '#E0DFDD',
          700: '#C8C7C5',
          800: '#B0AFAD',
          900: '#989795',
          950: '#807F7D',
        },
        'blue-light': '#DBE8ED',
        'shop-pay': '#5a31f4',
        'shop-pay-hover': '#3c0def',
        blue: '#b8d1dc',
        'discount-grey': '#767676',
        'discount-red': '#ad1f00',
        'discount-yellow': '#ab6701',
        error: '#b65151',
        focused: '#578995',
        grey: '#f5f5f5',
        'grey-dark': '#4d5559',
        shadow: '#00000030',
        success: '#3a7a69',
        'white-semi-transparent': '#ffffff80',
        yellow: '#FBB333',
      },
      fontSize: {
        '1xl': '1.375rem', // 22px
        '3.3xl': ['2rem', '2.625rem'], // 32px/42px
      },
      scale: {
        102: '1.02',
      },
      screens: {
        lg: '992px',
        '2xl': '1380px',
        '3xl': '1920px',
      },
      transitionTimingFunction: {
        'in-out-expo': 'cubic-bezier(.025,.115,.085,.99)',
        'in-out-sine': 'cubic-bezier(0.37, 0, 0.63, 1)',
      },
    },
  },
  plugins: [require('tailwindcss-capsize')({ mode: 'classic' })],
};
